export default {"src":"/_next/static/media/responsive.1b61e7fb.svg","height":30,"width":30};